import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CUSTOMER_ONBOARDING_EMAIL } from './schema';

const QUERY = gql`
  query CustomerOnboardingEmail($id: ID!) {
    customer(id: $id) {
      id
      onboardingEmail {
        ...CustomerOnboardingEmail
      }
    }
  }
  ${FRAGMENT_CUSTOMER_ONBOARDING_EMAIL}
`;

export const queryCustomerOnboardingEmail = (customerId) =>
  executeGqlQuery({
    query: QUERY,
    variables: { id: customerId },
  }).then(({ data }) => getSingleProp(data)?.onboardingEmail);
